import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  MenuItem,
} from '@mui/material'
import { authedAxios } from '../../../utils'

const PipleineSelectionModal = ({
  open,
  customer,
  onClose,
  onSubmit,
  pipelines,
  customerPipelineSummary,
}) => {
  const mapCustomerPipelineSummaryToSelection = (summary) => {
    return summary.pipelines.map((p) => {
      const pipelineId = p.id
      const stageId = p.stages.find((s) => s.customerIsInStage).id

      return [pipelineId, stageId]
    })
  }

  const [selectedPipelinesTuples, setSelectedPipelineTuples] = useState(
    mapCustomerPipelineSummaryToSelection(customerPipelineSummary)
  )

  useEffect(() => {
    setSelectedPipelineTuples(
      mapCustomerPipelineSummaryToSelection(customerPipelineSummary)
    )
  }, [customerPipelineSummary])

  const selectedPiplineIds = selectedPipelinesTuples.map((t) => t[0])

  const selectPipeline = (checked, id) => {
    if (!checked) {
      return setSelectedPipelineTuples(
        selectedPipelinesTuples.filter((t) => t[0] !== id)
      )
    }

    const firstStage = pipelines
      .find((p) => p.id === id)
      .stages.find((s) => s.displayOrder === 1)

    setSelectedPipelineTuples(
      selectedPipelinesTuples.concat([[id, firstStage.id]])
    )
  }

  const selectStage = (pipelineId, stageId) => {
    return setSelectedPipelineTuples(
      selectedPipelinesTuples.map((t) => {
        if (t[0] !== pipelineId) return t
        return [pipelineId, stageId]
      })
    )
  }

  const handleSubmit = () => {
    return authedAxios
      .put(`/api/customer/${customer.id}/stage`, {
        stages: selectedPipelinesTuples.map((t) => t[1]),
      })
      .then(customerPipelineSummary.refetch)
      .then(onSubmit)
  }

  return (
    <Dialog open={open}>
      <DialogTitle>Configure pipelines for {customer.name}</DialogTitle>
      <DialogContent>
        {pipelines
          .filter((p) => p.id !== '__OPPORTUNITIES__' && p.id !== '__TICKETS__')
          .map((p) => {
            const isSelected = selectedPiplineIds.includes(p.id)
            return (
              <Box key={p.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelected}
                      onChange={(_, checked) =>
                        selectPipeline(checked, p.id, p.stages)
                      }
                    />
                  }
                  label={p.name}
                />

                {isSelected && (
                  <Box sx={{ ml: 3, mb: 1 }}>
                    <TextField
                      fullWidth
                      select
                      value={
                        selectedPipelinesTuples.find((t) => t[0] === p.id)[1]
                      }
                      onChange={(e) => selectStage(p.id, e.target.value)}
                    >
                      {p.stages.map((s) => (
                        <MenuItem key={s.id} value={s.id}>
                          {s.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                )}
              </Box>
            )
          })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant={'outlined'}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant={'contained'}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PipleineSelectionModal
